// extracted by mini-css-extract-plugin
export default {"chip":"Chip_chip__Z1nLr","chip_active":"Chip_chip_active__2Uw92"};